import React, { useEffect, useState } from 'react'
import { AXIOS } from '../../api'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import { Icons } from '../common/Themes'

import { setFetch, setLoading, fetchConfigurations } from '../../redux/actions'

const ConfigGeneral = ({ toast, Toasky }) => {

    const dispatch = useDispatch()
    const history = useHistory()
    const { configurations } = useSelector(state => state.fetch)
    const [sliders, setSliders] = useState('')

    const { handleSubmit, register, errors } = useForm()
    const onSubmit = async values => {
        try {
            console.log(values)
            dispatch(setLoading(true))

            if (!!fileSlider?.name && true) {
                const uuid = uuidv4();
                console.log('inside : ', fileSlider)
                const formData = new FormData()
                formData.append('file', fileSlider)
                await AXIOS.post(`/api/v1/uploads/configurations/${uuid}`, formData);
            }

            // 👽 UPDATE CONFIGURATION REQUEST
            await AXIOS.patch(`/api/v1/configurations/${configurations[0]?.gid}`, values)
            history.push('/configurations')
            toast(<Toasky body="Les changements est bien effectué." />)
            dispatch(setFetch(!fetch))
            dispatch(setLoading(false))
        } catch (error) {
            console.log(error)
        }
    }

    const [imageSlider, setImageSlider] = useState('/img/default_image_acceil.png');
    const [fileSlider, setFileSlider] = useState()
    const fileInputSliderRef = React.useRef(null);

    useEffect(() => {
        // if(configurations[0]?.acceil)
        //     setImageSlider(`${process.env.REACT_APP_SITE_MARCHAND}${configurations[0]?.acceil}`)

        // setSliders(configurations[0]?.acceil)
    }, [configurations])

    const handleUploadSliderClick = () => {
        fileInputSliderRef.current.click();  // Trigger the hidden file input
    };

    const handleImageSliderChange = async (e) => {
        dispatch(setLoading(true))
        const file = e.target.files[0];
        const uuid = uuidv4();
        const formData = new FormData()
        formData.append('file', file)
        await AXIOS.post(`/api/v1/uploads/configurations/${uuid}`, formData);
        console.log(`/api/v1/uploads/configurations/${uuid}`)

        const data = { acceil: `${configurations[0]?.acceil},${uuid}` }
        await AXIOS.patch(`/api/v1/configurations/${configurations[0]?.gid}`, data)

        console.log(`${configurations[0]?.acceil}`)

        const res = await AXIOS.get(`/api/v1/configurations`);
        dispatch(fetchConfigurations(res.data.data.configurations));
        dispatch(setLoading(false))
    };

    const deleteAcceuilImage = async image => {
        dispatch(setLoading(true))
        const data = { acceil: configurations[0]?.acceil?.replace(`,${image}`, '') }
        await AXIOS.patch(`/api/v1/configurations/${configurations[0]?.gid}`, data)

        const res = await AXIOS.get(`/api/v1/configurations`);
        dispatch(fetchConfigurations(res.data.data.configurations));
        dispatch(setLoading(false))
    }

    return (
        <div className="configurations__bodyWrapper">
            <div className="gestion__header" style={{ marginBottom: '5rem' }}>
                <h4 className="gestion__title">configuration générale</h4>
            </div>
            <div className="configurations__body">
                <form onSubmit={handleSubmit(onSubmit)} className="configurations__form">


                    <div style={{ width: '100%' }}>
                        <div className="form__inputbox" style={{ width: '485px' }}>
                            <label htmlFor="addresses" className="form__label">Posts on reseau</label>
                            <input name="addresses" defaultValue={configurations[0]?.addresses} ref={register()} type="text" className="form__input" />
                        </div>
                    </div>


                    <div className="configurations__formWrapper">
                        <div className="configurations__inputWrapper">
                            <div className="form__inputbox" style={{ width: '73%', marginRight: '2rem' }}>
                                <label htmlFor="heitzUrl" className="form__label">Heitz url</label>
                                <input name="heitzUrl" defaultValue={configurations[0]?.heitzUrl} ref={register()} type="text" className="form__input" />
                            </div>
                            <div className="form__inputbox" style={{ width: '110px' }}>
                                <label htmlFor="heitzPort" className="form__label">Heitz port</label>
                                <input name="heitzPort" defaultValue={configurations[0]?.heitzPort} ref={register()} type="text" className="form__input" />
                            </div>
                        </div>
                        <div className="configurations__inputWrapper">
                            <div className="form__inputbox" style={{ width: '73%', marginRight: '2rem' }}>
                                <label htmlFor="serverUrl" className="form__label">Serveur url</label>
                                <input name="serverUrl" defaultValue={configurations[0]?.serverUrl} ref={register()} type="text" className="form__input" />
                            </div>
                            <div className="form__inputbox" style={{ width: '110px' }}>
                                <label htmlFor="serverPort" className="form__label">Serveur port</label>
                                <input name="serverPort" defaultValue={configurations[0]?.serverPort} ref={register()} type="text" className="form__input" />
                            </div>
                        </div>
                    </div>

                    <div className="" style={{ marginTop: '10px' }}>
                        <div className="borne__label" style={{ fontSize: '13px', marginBottom: '10px' }}>écran de veille</div>
                        <div className="">
                            <input ref={fileInputSliderRef} type="file" accept="image/*" onChange={handleImageSliderChange} style={{ display: 'none' }} />
                            <img onClick={handleUploadSliderClick} src="/img/icon/upload.svg" alt="upload" style={{ width: '40px', cursor: 'pointer' }} />
                        </div>
                        <div style={{ display: 'flex', marginTop: '8px' }}>
                            {configurations[0]?.acceil?.split(',')?.map((image) => {
                                if (image) {
                                    return (
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '20px' }}>
                                            <img src={`${process.env.REACT_APP_SITE_MARCHAND}/uploads/configurations/${image}.png`} alt="" style={{ width: '200px' }} />
                                            <Icons onClick={() => deleteAcceuilImage(image)} style={{ margin: '6px 0 0 0', width: '20px', height: '20px' }} color={"#FF5C00"}>
                                                <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                                            </Icons>
                                        </div>
                                    );
                                } else {
                                    return;
                                }
                            })}
                        </div>
                    </div>

                    <button className="configurations__button">Sauvegarder</button>
                </form>
            </div>
        </div>
    );
}

export default ConfigGeneral